class SiteAnalytics {
  constructor() {
    this.init();
  }
  setupEventListeners() {
    this.addCtaAnchorLinkListeners();
    this.addAppWebsterBankLinkListeners();
  }
  /*----//  Anchor link to form click events  //----*/
  addCtaAnchorLinkListeners() {
    const getAnchorElements = document.querySelectorAll(
      ".section-anchor[name]"
    );
    /*----//  Set up anchor link CTA clicks datalayerpushes  //----*/
    if (getAnchorElements.length > 0) {
      getAnchorElements.forEach((anchor) => {
        const getAnchorLinkName = anchor.getAttribute("name");
        const getAnchorLinks = document.querySelectorAll(
          `a[href="#${getAnchorLinkName}"]`
        );
        const getAnchorParent = anchor.closest(".section");
        getAnchorLinks.forEach((link) => {
          link.addEventListener("click", (event) => {
            if (getAnchorParent.querySelector("form") || getAnchorLinkName === "page-form" || getAnchorLinkName === "page-contact") {
              this.pushDataLayerEvent(event, "ctaGoToForm");
            }
          });
        });
      });
    }
  }

  /*----//  Check for app.websterbank.com Links  //----*/
  addAppWebsterBankLinkListeners() {
    const getWebsterBankLinks = document.querySelectorAll(
      'a[href*="app.websterbank.com"]'
    );
    if (getWebsterBankLinks.length > 0) {
      getWebsterBankLinks.forEach((link) => {
        link.addEventListener("click", (event) =>
          this.pushDataLayerEvent(event, "ctaStartCDAO")
        );
      });
    }
  }

  /*----//  Push datalayer event  //----*/
  pushDataLayerEvent(event, eventType) {
    const dataLayerObject = {};
    switch (eventType) {
      case "ctaGoToForm":
      case "ctaStartCDAO":
        const getCtaButton = event.target.closest("a.button");
        /*----//  Check for CTA Go To Form  //----*/
        const isAnchorLink = getCtaButton.hash !== "" ? true : false;
        const isAppWebsterBankLink = getCtaButton.href.includes(
          "app.websterbank.com"
        )
          ? true
          : false;
        if (isAnchorLink || isAppWebsterBankLink) {
          dataLayerObject.event = eventType;
          dataLayerObject.product = window.location.pathname;
        }
        break;

      default:
        break;
    }
    if (Object.keys(dataLayerObject).length > 0) {
      window.dataLayer.push(dataLayerObject);
    } else {
      return console.info("No dataLayer object to push");
    }
  }

  init() {
    this.setupEventListeners();
  }
}

export default SiteAnalytics;

/**----//
------------------------------------------🧿--🧿

Initialize Site Analytics

------------------------------------------🧿--🧿
//----*/
const setUpAnalytics = () => {
  const siteAnalytics = new SiteAnalytics();
  return siteAnalytics;
};
document.addEventListener("DOMContentLoaded", setUpAnalytics);
